export const environment = {
  production: false,
  dashboardMocks: true,
  server: 'https://dlap-gateway.dev.dokuma.co.zw/deeds/',
  portalUrls: {
    deeds: 'https://deeds.v2.dokuma.co.zw',
    bank: 'https://ebanking.v2.dokuma.co.zw',
    lawFirm: 'https://econveyancer.v2.dokuma.co.zw',
    highCourt: 'https://ecourt.v2.dokuma.co.zw',
  },
};
